import {Icon, Layout, SelectItemContent, Text} from '@eitje/web_components'
import {FIRM_ICON_MAPPING} from '../cells/firm_icon_mapping'

export const FirmTypeFilterItem = ({item, checkboxProps}) => {
	const {id, t} = item
	const icon = FIRM_ICON_MAPPING[id] || {}
	return (
		<Layout checked gap={16}>
			<SelectItemContent checkboxProps={checkboxProps}>
				<Icon name={icon} />
				<Text t={t} />
			</SelectItemContent>
		</Layout>
	)
}
